var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"rackman-image",attrs:{"src":("img/icons/" + _vm.image),"height":"30px","width":"30px"}})}
var staticRenderFns = []

export { render, staticRenderFns }